export enum parametersEnum {
    HuhKR9TYCA= 'headers',
    lGPk9gpIc4= 'warningDisplay',
    iaSeGSYpsm= 'daliEnvProd',
    y8Ybi4g1UG= 'security_sso',
    slMjaw3ZxU= 'login',
    hnW6xJ7SIr= 'client_id',
    rYz7A5DBId= 'client_secret',
    CSk7Gw0oYv= 'grant_type',
    y0FDwH869X= 'login_op',
    oGwgAr1I2c= 'crypto',
    jjMjp4BCUy= 'criptovault',
    GygGhCKMH1= 'time_expiration',
    B2Qd6ZR17g= 'time_grace',
    KOAZ5rc7Rv= 'clientless',
    yySwltKjNf= 'web_id',
    B9yIqGV2F4= 'application',
    oVr7sPqm04 = 'enrollment',
    tTvfir1GRC= 'active',
    UB0RWW6Ybs= 'creditCard',
    biuHOF7q6H= 'revolvingCredit',
    CikSZR2LFg= 'freeInvestment',
    KMTos5rJn4= 'livingPlace',
    gTyn1nn5BN= 'loan',
    ptMCPwN3NX= 'LBR',
    uBFsFkiZEI= 'pasive',
    zASAT9C5WE= 'payroll',
    sFc6Ol5pj0= 'NOMINA',
    xVrMp1Uufd= 'savings',
}
